/* eslint-disable */
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Radio, message } from 'antd';
import { getFolioDescarga } from 'actions/downloads.actions';
import PropTypes from 'prop-types';
import { DOWNLOAD_TYPES } from 'constants/downloadTypes';
import DownloadModal from 'components/InfoModal/Download/DownloadModal';
import ReportesDinamicos from 'components/ReportesDinamicos/ReportesDinamicos';
import iconPdf from 'assets/images/SelectorDescargaImage/Icono_PDF.svg';
import iconTodo from 'assets/images/SelectorDescargaImage/Icono_Todo.svg';
import iconExcel from 'assets/images/Excel_.svg';
import iconReporteDinamico from 'assets/images/SelectorDescargaImage/Icono_repor_din.svg';
import Button from '../Button/Button';
import './SelectorTipoDescarga.scss';

export const SelectorTipoDescarga = (props) => 
{
  const [downloadType, setDownloadType] = useState(DOWNLOAD_TYPES.TESTIGOS.value);
  const [isVisibleSuccesModal, setIsVisibleSuccessModal] = useState(false);
  const [isVisibleModalCampos, setIsVisibleModalCampos] = useState(false);
  const [isLoadingButtonDescarga, setLoadingButtonDescarga] = useState(false);
  const [isLoadingButtonCampos, setLoadingButtonCampos] = useState(false);
  const [isTextButtonDownload, setTextButtonDownload] = useState('Agregar a cola de descarga');
  const [idDescarga, setIdDescarga] = useState('');
  const dispatch = useDispatch();
  const handleChangeType = (event) => {
    const { target } = event;
    if (target.value === DOWNLOAD_TYPES.DINAMICOS.value) {
      setTextButtonDownload('Generar reporte');
    } else {
      setTextButtonDownload('Agregar a cola de descarga');
    }
    setDownloadType(target.value);
  };

  const { tipoMonitoreo, tipoActa, procesarTodo } = props;
  const datosUser = useSelector((state) => state?.validarUsuario?.data);

  const getMonitoreosSeleccionados = () => {
    const monitoreos = [];
    const { seleccion } = props;
    let validacion = false;
    Object.entries(seleccion.current).forEach(([key, value]) => {
      if (value) {
        validacion = true;
        monitoreos.push(key);
      }
    });
    if (!validacion) {
      return null;
    }
    return monitoreos;
  };

  const handleOnCloseModal = () => {
    const { onClearSeleccion } = props;
    onClearSeleccion?.();
    setIsVisibleSuccessModal(false);
    setLoadingButtonDescarga(false);
  };

  const handleOnCloseModalCampos = () => {
    const { onClearSeleccion } = props;
    onClearSeleccion?.();
    setIsVisibleModalCampos(false);
    setLoadingButtonCampos(false);
    setLoadingButtonDescarga(false);
  };

  const generarReporteDinamico = async (formCampos) => {
    setLoadingButtonCampos(true);
    const camposSeleccionados = await formCampos.validateFields();
    const listaIds = getMonitoreosSeleccionados();
    const { success, response } = await dispatch(
      getFolioDescarga({
        tipoDescarga: downloadType,
        tipoMonitoreo,
        tipoActa,
        listaIdMonitoreos: listaIds,
        camposDinamicos: camposSeleccionados
      })
    );
    if (success) {
      setIsVisibleSuccessModal(true);
      setIdDescarga(response.data.folio_descarga);
      handleOnCloseModalCampos();
      formCampos.resetFields();
    }
  };

  const handleAddDownload = async () => 
  {
    console.log('Entra a descargar');
    const listaIds = getMonitoreosSeleccionados();
    if (listaIds !== null) 
    {
      setLoadingButtonDescarga(true);
      if (downloadType !== DOWNLOAD_TYPES.DINAMICOS.value) 
      {
        const { success, response } = await dispatch(
          getFolioDescarga({
              tipoDescarga: downloadType
            , tipoMonitoreo
            , tipoActa
            , listaIdMonitoreos: listaIds
            , procesarTodo: procesarTodo
          })
        );
        if (success) {
          setIsVisibleSuccessModal(true);
          setIdDescarga(response.data.folio_descarga);
        }
      } else {
        setIsVisibleModalCampos(true);
      }
    } else {
      message.error('Debes seleccionar al menos un monitoreo para descarga.');
    }
  };

  return (
    <div className="selector-tipo-descarga">
      <DownloadModal
        visible={isVisibleSuccesModal}
        onClose={handleOnCloseModal}
        idDescarga={idDescarga}
      />
      <ReportesDinamicos
        visible={isVisibleModalCampos}
        onClose={handleOnCloseModalCampos}
        generarReporte={generarReporteDinamico}
        tipoMonitoreo={tipoMonitoreo}
        tipoActa={tipoActa}
        isLoading={isLoadingButtonCampos}
      />
      <p className="description">¿Qué deseas descargar?</p>
      <div className="download-type-container">
        {datosUser.rol.includes('REPRESENTANTEFINANZAS') &&
        tipoMonitoreo === 1 &&
        (tipoActa === 1 || tipoActa === 3) ? (
          <Radio.Group onChange={handleChangeType} value={downloadType}>
            <Radio value={DOWNLOAD_TYPES.TESTIGOS.value}>
              <div className="opcion-descarga">
                <img src={iconPdf} alt="" />
                {/* <FilePdfOutlined style={{ fontSize: '55px' }} /> */}
                <span>{DOWNLOAD_TYPES.TESTIGOS.label}</span>
              </div>
            </Radio>
          </Radio.Group>
        ) : (
          <Radio.Group onChange={handleChangeType} value={downloadType}>
            <Radio value={DOWNLOAD_TYPES.TESTIGOS.value}>
              <div className="opcion-descarga" style={{ width: '60px' }}>
                <img src={iconPdf} alt="" width="44.32" style={{ fontSize: '100px' }} />
                {/* <FileExcelOutlined style={{ fontSize: '55px' }} /> */}
                <span>
                  {DOWNLOAD_TYPES.TESTIGOS.label}
                  <br />
                  &nbsp;
                </span>
              </div>
            </Radio>
            <Radio value={DOWNLOAD_TYPES.SABANAS.value}>
              <div className="opcion-descarga" style={{ width: '60px' }}>
                <img src={iconExcel} alt="" width="48.32" style={{ fontSize: '100px' }} />
                {/* <FileExcelOutlined style={{ fontSize: '55px' }} /> */}
                <span>
                  {DOWNLOAD_TYPES.SABANAS.label}
                  <br />
                  &nbsp;
                </span>
              </div>
            </Radio>
            <Radio value={DOWNLOAD_TYPES.TODO.value}>
              <div className="opcion-descarga" style={{ width: '60px' }}>
                <img src={iconTodo} alt="" width="48.32" style={{ fontSize: '100px' }} />
                {/* <FileExcelOutlined style={{ fontSize: '55px' }} /> */}
                <span>{DOWNLOAD_TYPES.TODO.label}</span>
              </div>
            </Radio>
            <Radio value={DOWNLOAD_TYPES.DINAMICOS.value}>
              <div className="opcion-descarga" style={{ width: '60px' }}>
                <img src={iconReporteDinamico} alt="" width="44.32" style={{ fontSize: '100px' }} />
                {/* <FileExcelOutlined style={{ fontSize: '55px' }} /> */}
                <span>{DOWNLOAD_TYPES.DINAMICOS.label}</span>
              </div>
            </Radio>
          </Radio.Group>
        )}
      </div>
      <div className="action-container">
        <Button
          text={isTextButtonDownload}
          type="primary"
          onClick={handleAddDownload}
          loading={isLoadingButtonDescarga}
        />
      </div>
    </div>
  );
};

SelectorTipoDescarga.propTypes = {
  seleccion: PropTypes.shape({ current: PropTypes.shape({ forEach: PropTypes.func }) }).isRequired,
  tipoMonitoreo: PropTypes.number.isRequired,
  tipoActa: PropTypes.number.isRequired,
  onClearSeleccion: PropTypes.func
};

SelectorTipoDescarga.defaultProps = {
  onClearSeleccion: () => {
    // handleClose function here
  }
};

export default SelectorTipoDescarga;
